import { useEffect } from 'react';
import { useDispatcherVideoContext } from './DispatcherVideoContext/useDispatcherVideoContext';

export function useFullScreen() {
  const { isFullscreen, setIsFullscreen, toggleFullscreen } =
    useDispatcherVideoContext();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isFullscreen) {
        setIsFullscreen(false);
      }
    };

    if (isFullscreen) {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [isFullscreen, setIsFullscreen]);

  return {
    isFullscreen,
    setIsFullscreen,
    toggleFullscreen,
  };
}
